import type { ComponentPropsWithoutRef } from 'react';
import type React from 'react';

import { ShortUrlsStateContextProvider } from './context';
import { ShortUrlsCacheQueueProvider } from './queue';

export const ShortUrlsCacheProvider: React.FC<ComponentPropsWithoutRef<typeof ShortUrlsStateContextProvider>> = ({
	children,
	...rest
}) => {
	return (
		<ShortUrlsStateContextProvider {...rest}>
			<ShortUrlsCacheQueueProvider>{children}</ShortUrlsCacheQueueProvider>
		</ShortUrlsStateContextProvider>
	);
};
